import React, {useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';

import InfoCard from '../../components/info-card/info-card.jsx';
import GallerySlide from '../../components/gallery-slide/gallery-slide.jsx';
import ContactForm from '../../components/contact-form/contact-form.jsx';
// import ImageInfo from '../../components/image-info/image-info.jsx';
import InfoBox from '../../components/info-box/info-box.jsx';
import OverlayTextImage from '../../components/overlay-text-image/overlay-text-image.jsx';

import './welcome-wrapper.css';

const WelcomeWrapper = ({data, isMobile}) => {

  const serviceCards = data?.serviceCards?.map((card, index) => {
    return (
      <div className="col-sm-12 col-md-6 col-lg-3" key={index}>
        <InfoCard title={card?.title} text={card?.text}/>
      </div>
    )
  })

  // const sideBySideContent = data?.sideBySideContent.map((card, index) => {
  //   return (
  //     <div className="margin-top-5 sliding-container" key={index}>
  //       <ImageInfo 
  //         title={card.title} 
  //         text={card.text} 
  //         image={card.image} 
  //         isImageOnTheLeft={isMobile || card.isImageOnTheLeft}/>
  //     </div>
  //   )
  // })

  // const footerIcons = data?.footer?.socials.map((icon, index) => {
  //   return (
  //     <span key={index}>
  //       <a href={icon.link} target="_blank" rel="noreferrer" className="default-link">
  //         <i className={`social-icon fab fa-${icon.icon}`}></i>
  //       </a>
  //     </span>
  //   )
  // })

  return (
    <div className="welcome-dashboard-wrapper relative-position">
        <Helmet>
            <title>Serene Manor Adult Family Home - Care & Support Services</title>
            <meta property="og:title" content="Welcome to Serene Manor Adult Family Home" />
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://www.theserenemanorafh.com" />
            <meta property="og:image" content={data?.landingImage?.image} />
            <meta property="og:description" content={`Serene Manor Adult Family Home - ${data?.landingImage?.text}`} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="Welcome to Serene Manor Adult Family Home" />
            <meta name="twitter:description" content={`Serene Manor Adult Family Home - ${data?.landingImage?.text}`} />
            <meta name="twitter:image" content={data?.landingImage?.image} />
            <meta name="description" content={`Serene Manor Adult Family Home - ${data?.landingImage?.text} Here you will find the services we provide and our contact information. We would love to hear from you about how we can support your loved ones, so please do not hesitate to contact us.`} />
            <link rel="canonical" href="https://www.theserenemanorafh.com" />
            <script type="application/ld+json">
              {JSON.stringify({
                "@context": "https://schema.org",
                "@type": "LocalBusiness",
                "name": "Serene Manor Adult Family Home",
                "image": "https://www.theserenemanorafh.com/assets/images/serene_manor_logo_mini.png",
                "@id": "https://www.theserenemanorafh.com",
                "url": "https://www.theserenemanorafh.com",
                "telephone": data?.contactDetails?.phone,
                "description": data?.landingImage?.text,
                "address": {
                  "@type": "PostalAddress",
                  "streetAddress": data?.contactDetails?.address
                },
                "sameAs": data?.footer?.socials?.map(s => s.link) || []
              })}
            </script>
        </Helmet>
        <div className="home-body relative-position">

          <OverlayTextImage  
            image={data?.landingImage?.image} 
            title={data?.landingImage?.title} 
            slogan={data?.landingImage?.slogan}
            text={data?.landingImage?.text}
            alt={data?.landingImage?.alt}
            />

          <div className="row margin-bottom-5">
            <InfoBox 
              boxStyleClass="mission-statement-mobile"
              styleClass="mobile-small-block-text" 
              title={data?.mission?.title} text={data?.mission?.text}/>
          </div>
          
          
          {isMobile?  
            <div className="row">
              <InfoBox title={data?.serviceTitle} isTitleOnly={true}/>
            </div> : ""
          }
          
          <div className="cards row">
            {serviceCards}
          </div>
          
          {/* {sideBySideContent} */}

          <GallerySlide 
            images={data?.imageSlideShow} 
            showThumbnails={true}/>

          <div className="margin-top-5">
            <ContactForm 
              detailsTitle={data?.contactDetails?.title} 
              phone={data?.contactDetails?.phone} 
              fax={data?.contactDetails?.fax} 
              email={data?.contactDetails?.email} 
              address={data?.contactDetails?.address} 
              addressLink={data?.contactDetails?.addressLink} 
              showWithTwoColumns={true} />
          </div>
        </div>
        <div className='footer full-width margin-top-5'>
          {/* <div className="container center">
            <div>
             {footerIcons}
            </div>
          </div> */}
          <div className="container center">
            <p>&copy; {data?.footer?.text}</p>
          </div>
        </div>
    </div>
  );

}

export default WelcomeWrapper;